import { useEffect, useRef } from 'react';
import { useInView } from 'framer-motion';
import { logInfo } from 'app/services/logger';

import useLastReadMessageIndex from '../hooks/useLastReadMessageIndex';

export function MessageReadMarker({ index = 0 }: { index?: number }) {
  const { ready, lastReadMessageIndex, markIndexAsRead } = useLastReadMessageIndex();

  const ref = useRef<HTMLDivElement>(null);
  const inView = useInView(ref);

  const isRead = index <= lastReadMessageIndex;

  useEffect(() => {
    if (lastReadMessageIndex === 0) {
      markIndexAsRead(index);
    }
  }, [lastReadMessageIndex, index, markIndexAsRead]);

  useEffect(() => {
    if (inView && !isRead && ready && index > 0) {
      markIndexAsRead(index);
      logInfo(`Message index ${index} is read`);
    }
  }, [inView, index, isRead, markIndexAsRead, ready]);

  if (isRead) return null;

  return (
    <div
      ref={ref}
      className="absolute bottom-0 right-0 left-0"
    />
  );
}
